var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_GET_B_TO_C_HISTORY, API_GET_B_TO_C_PREVIEW } from ".";
import { parseBToCMessage } from "./utils/b_to_c.utils";
// public
export const getBToCPreview = (address, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_B_TO_C_PREVIEW, {
            params: { address },
        });
        const messages = response.data;
        return messages.map((msg) => parseBToCMessage(msg));
    }
    catch (err) {
        return [];
    }
});
export const getBToCHistory = (fromAddress, toDomain, api, referenceMessageId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_B_TO_C_HISTORY, {
            params: { from_address: fromAddress, to_domain: toDomain, referenceMessageId: referenceMessageId },
        });
        const messages = response.data.results;
        return {
            "next": response.data.next,
            "previous": response.data.previous,
            "results": messages.map((msg) => parseBToCMessage(msg))
        };
    }
    catch (err) {
        return {};
    }
});
//# sourceMappingURL=b_to_c.js.map